import { render, staticRenderFns } from "./xeChartRadar.vue?vue&type=template&id=540a304a&scoped=true"
import script from "./xeChartRadar.vue?vue&type=script&lang=js"
export * from "./xeChartRadar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a304a",
  null
  
)

export default component.exports